import { global } from "../../constants";

export const data = {
    banner: {
        background: global.banner + "contactus.webp",
        title: "Contáctanos",
        base: "Inicio",
        crumb: "Contáctanos",
        sendMessage: "Envíanos un mensaje",
        submitNow: "Enviar ahora",
        contactUs: "Pongámonos en contacto",
        name: "Nombre",
        email: "Correo Electrónico",
        phone: "Número de Teléfono",
        subject: "Asunto",
        message: "Mensaje",
    }
}